// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"history-details_loader-container__2mjDf","loaderContainer":"history-details_loader-container__2mjDf","hidden-ninja":"history-details_hidden-ninja__2Lf1K","hiddenNinja":"history-details_hidden-ninja__2Lf1K","full-height":"history-details_full-height__2HlFs","fullHeight":"history-details_full-height__2HlFs","wrapper":"history-details_wrapper__31rzB","date":"history-details_date__3FQ2D","title":"history-details_title__iwPsz"};
    if(module.hot) {
      // 1732214789320
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  